<div *ngIf="isVisible" fxLayout="column">
  <mat-checkbox autofocus
                [id]="'nc-checkbox-' + id"
                [name]="name"
                [formControl]="control"
                [ngClass]="{'is-invalid' : isControlInvalid()}"
                [labelPosition]="labelPosition"
                [color]="color"
  >
    {{label | translate}}
  </mat-checkbox>
  <mat-error *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</div>
